import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/content";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  const go = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <footer className="bg-primary-900 py-12 md:py-16">
        <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
          <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
            <div className="max-w-sm">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-sparkling-2-fill text-lg"></i>
                </span>
                <span className="font-heading text-xl text-background-50">火影黄本子</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-primary-100">
                一个把火影玩坏的地方。聚合魔改解说、神吐槽、沙雕图与弹幕梗，
                每天都有新乐子，截图分享一起嗨。
              </p>
              <div className="mt-5 flex items-center gap-3 text-primary-200">
                <a
                  href="#top"
                  aria-label="微博"
                  onClick={(e) => {
                    e.preventDefault();
                    go("top");
                  }}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-100/30 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className="ri-weibo-fill"></i>
                </a>
                <a
                  href="#top"
                  aria-label="哔哩哔哩"
                  onClick={(e) => {
                    e.preventDefault();
                    go("top");
                  }}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-100/30 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className="ri-bilibili-fill"></i>
                </a>
                <a
                  href="#top"
                  aria-label="小红书"
                  onClick={(e) => {
                    e.preventDefault();
                    go("top");
                  }}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-100/30 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className="ri-chat-heart-fill"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
              <div>
                <h4 className="font-heading text-base text-background-50">内容栏目</h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {["魔改解说", "神吐槽", "沙雕图集", "爆笑名场面"].map((t) => (
                    <li key={t}>
                      <a
                        href="#hot"
                        onClick={(e) => {
                          e.preventDefault();
                          go("hot");
                        }}
                        className="text-sm text-primary-100 transition-colors hover:text-secondary-400"
                      >
                        {t}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="font-heading text-base text-background-50">快速导航</h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {navLinks.map((l) => (
                    <li key={l.id}>
                      <a
                        href={`#${l.id}`}
                        onClick={(e) => {
                          e.preventDefault();
                          go(l.id);
                        }}
                        className="text-sm text-primary-100 transition-colors hover:text-secondary-400"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="font-heading text-base text-background-50">联系投稿</h4>
                <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-100">
                  <li className="inline-flex items-center gap-2">
                    <i className="ri-mail-line"></i>
                    fun@huangbenzi.top
                  </li>
                  <li className="inline-flex items-center gap-2">
                    <i className="ri-wechat-line"></i>
                    公众号：火影黄本子
                  </li>
                  <li>
                    <a
                      href="#subscribe"
                      onClick={(e) => {
                        e.preventDefault();
                        go("subscribe");
                      }}
                      className="whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-secondary-600"
                    >
                      投稿你的梗图
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-100/20 pt-6 sm:flex-row">
            <p className="text-xs text-primary-200">
              © {new Date().getFullYear()} 火影黄本子 · 仅供娱乐 · 原创恶搞内容
            </p>
            <p className="text-xs text-primary-200">开心追番，快乐玩梗</p>
          </div>
        </div>
      </footer>

      {showTop && (
        <button
          type="button"
          aria-label="返回顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </>
  );
}